import { InsertLinkRounded } from '@mui/icons-material';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Popover,
    TextField,
    ToggleButton,
    Tooltip,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { Editor, Element, Range, Transforms } from 'slate';
import { useSlate } from 'slate-react';
import useSelectedBlock from '../hooks/useSelectedBlock';
import { useTranslation } from 'react-i18next';
import useEmailEditor from '@hooks/useEmailEditor';

const useLink = () => {
    const editor = useSlate();

    const { type } = useSelectedBlock();

    const unwrapLink = () => {
        Transforms.unwrapNodes(editor, {
            match: n =>
                !Editor.isEditor(n) &&
                Element.isElement(n) &&
                n.type === 'link',
        });
    };

    const inserLink = (url: string) => {
        const isLink = type === 'link';
        if (isLink) unwrapLink(editor);

        const { selection } = editor;
        const isCollapsed = selection && Range.isCollapsed(selection);
        const link = {
            type: 'link',
            attributes: { href: url, target: '_blank' },
            children: isCollapsed ? [{ text: url }] : [],
        };

        if (isCollapsed) {
            Transforms.insertNodes(editor, link);
        } else {
            Transforms.wrapNodes(editor, link, { split: true });
            Transforms.collapse(editor, { edge: 'end' });
        }
    };

    return { inserLink, removeLink: unwrapLink };
};

function LinkButton() {
    const { t } = useTranslation();
    const { setLinkOpen } = useEmailEditor();

    return (
        <>
            <Tooltip title={t('Add Link')}>
                <ToggleButton
                    value={false}
                    onMouseDown={e => {
                        e.preventDefault();
                        setLinkOpen(true);
                    }}
                >
                    <InsertLinkRounded fontSize="small" />
                </ToggleButton>
            </Tooltip>
        </>
    );
}

export default LinkButton;
